export const StatusComprometimento = {
    NAO_COMPROMETIDO: 0,
    COMPROMETIDO: 1,
    ATUALIZAR_COMPROMETIMENTO: 2,
    ERRO: 3,
    EXCLUIR_COMPROMETIMENTO: 4,
    COMPROMETIMENTO_EXCLUIDO: 5
}
